import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import CreateTransmissionForm from '../../../modules/transmissions/components/CreateTransmissionForm';
import { useParams } from 'react-router-dom';

const CreateTransmission = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const title = id ? t('edit_transmission') : t('create_transmission');
  dispatch(
    setBreadCrumbsData({
      links: [{ label: title, path: '/transmissions/create-transmission' }],
      page_title: title
    })
  );

  return (
    <div>
      <CreateTransmissionForm />
    </div>
  );
};

export default CreateTransmission;
